export default {
    i18n: {
        "Device Name": "设备名",
        "day": "日",
        "Device Information": "设备信息",
        "handset": "手柄",
        "Access Denied.": "开门失败",
        "Date Time": "时间",
        "name": "注册名",
        "Fingerprint": "指纹",
        "tamperAlarm": "防拆告警",
        "Http": "HTTP",
        "Volume": "音量",
        "Card": "卡",
        "minutes": "分钟",
        "timezone": "时区",
        "Are you sure you want to delete this device?": "是否要删除设备？",
        "Attendance Point Name": "考勤点",
        "Mac": "MAC",
        "confirmToDeleteIt?": "您确定要删除它吗？",
        "captureLogs": "截图记录",
        "Doors": "门",
        "All Doors": "所有门",
        "Lock List": "锁列表",
        "Link Device Relay": "关联设备继电器",
        "Added Successfully!": "添加成功！",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "当锁跟继电器关联，您可通过开继电器来开锁。",
        "Adding...": "新增中...",
        "Please try again 24 hours later.": "请24小时后再试",
        "Action": "操作",
        "Address": "地址",
        "Owner": "所属者",
        "Failed": "失败",
        "Timeout": "超时",
        "Response": "操作结果",
        "caller": "主叫方",
        "receiver": "接收",
        "doorLogs": "开门记录",
        "callHistory": "呼叫记录",
        "UID": "UID",
        "Call Type": "呼叫方式",
        "Code": "密钥",
        "User": "用户",
        "Device List": "设备列表",
        "Model": "型号",
        "Time": "时间",
        "Company": "公司",
        "Property Managers": "物业管理员",
        "Current Version": "当前版本",
        "indoorMonitor": "室内机",
        "guardPhone": "管理机",
        "close": "关闭",
        "Success": "成功",
        "URL": "连接地址",
        "Please select a device.": "请选择一个设备",
        "Password is too weak.": "密码太简单",
        "Company is required.": "请输入公司名",
        "Your account is not activated, please contact your service provider.": "您的账号未激活，请联系您的服务提供商",
        "Language": "语言",
        "Face": "人脸",
        "Please set at least one access type.": "请设置至少一种门禁方式",
        "Please contact your service provider to activate this advanced feature.": "请联系你的服务提供商开通此高级功能。",
        "Community name": "社区名",
        "Please enable PM App first.": "请先开启物业管理员App",
        "Username": "用户名",
        "Change Log": "变更记录",
        "Assign": "分配",
        "Floor": "楼层",
        "Link Device": "连接设备",
        "Accessible Floors": "可达楼层",
        "Upgrade": "升级",
        "Function": "功能",
        "callDuration": "通话时间",
        "No": "否",
        "Verification Code": "验证码",
        "Expiration Time": "过期时间",
        "PIN": "密码",
        "MAC": "MAC",
        "Building": "楼栋",
        "APT": "房间",
        "ID": "ID",
        "Name": "名称",
        "activities": "使用记录",
        "Obtain": "获取",
        "call": "呼叫",
        "Group Call": "群呼",
        "Delete": "删除",
        "Yes": "是",
        "Door Release PIN": "开门密码",
        "Email": "邮箱",
        "Mobile Number doesn\'t exist.": "手机号不存在。",
        "Tips": "提示",
        "Password": "密码",
        "The end time cannot be earlier than the start time.": "结束时间不可早于开始时间!",
        "Back": "返回",
        "File format error.": "文件格式错误。",
        "motionDetection": "移动侦测",
        "You are trying too often, please try again in 5 minutes": "由于您尝试次数过多，请在5分钟后再次尝试",
        "User name too long.": "用户名太长，用户名最多可以包含63个字符",
        "This MAC address is redirected on RPS.": "此MAC地址在RPS上重定向",
        "No Answer": "未接听",
        "failedToUnlock": "开门失败",
        "visitor": "访客",
        "yesterday": "昨天",
        "Too large data! Please first export the data before %s first,thanks.": "请先导出 %s 之前的数据",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "请检查是否有待支付订单。如果没有，请联系您的服务提供商",
        "lock": "关门",
        "open": "开门",
        "The PersonalAccount is not active.": "账号未激活。",
        "You cannot link an account that already link other accounts.": "您不能绑定已经有多套房的账号。",
        "You cannot link multiple property manager accounts under the same installer account.": "您不能绑定同一个安装商账号下的物业管理员账号。",
        "You cannot link to the currently logged in account.": "你不能绑定您当前登录的账号。",
        "nfc": "NFC",
        "Delete Device": "删除设备",
        "date": "日期",
        "Device deleted successfully": "删除设备成功",
        "Failed to delete device": "删除设备失败",
        "Are you sure you want to cancel?": "你确定要取消吗？",
        "Unlimited": "无限的",
        "Password Incorrect.": "密码不正确。",
        "deliverySystemVerification": "快递验证",
        "auto": "自动",
        "Group": "群组",
        "None": "空",
        "unlock": "开门",
        "Upgrading...": "正在升级...",
        "amenityReservation": "公共场所预约",
        "idAccess": "身份证访问",
        "RF Card": "门禁卡",
        "exitButton": "开门按钮",
        "Please select at least one item.": "请至少选择一项",
        "The ID can contain only digits and letters, up to 32 characters.": "ID只能是数字或字母，最多32位",
        "The PIN is not available.": "此密码不可用",
        "Change WiFi": "更换 WiFi",
        "Phone number": "电话号码",
        "Invalid {0}.": "{0}无效",
        "{0} already exists.": "{0}已存在",
        "Operation failed!": "操作失败！",
        "Failed to get data.": "获取数据失败",
        "You do not have the necessary permissions to perform this operation.": "您无权操作",
        "You can only import one template at a time in the current site.": "每次只能导入一个模板",
        "Delivery name": "快递员授权名称",
        "MAC address not in the MAC library.": "MAC地址未在MAC库中",
        "Please delete devices under this building.": "请先删除此楼栋下的设备",
        "The start time cannot be later than the end time.": "开始时间不可晚于结束时间",
        "emergency action type": "紧急告警动作类型",
        "Only 1000 data items can be imported at a time.": "一次最多导入1000个数据",
        "The password is too short.": "密码太短",
        "The data has been updated. Please refresh the page and try again.": "数据已更新，请刷新页面并重试。",
        "AutoP length must be less 2048 bytes.": "AutoP命令长度需小于2048字节",
        "File Check Failed": "文件检查失败",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "管理员账号已过期，请联系您的服务提供商。",
        "iqPinVerificationFailed": "IQ PIN校验失败。",
        "accountBlacklisted": "账号被拉黑。",
        "outsideAuthorizedTime": "不在有效时间内。",
        "network group": "网络组",
        "Company name": "公司名称",
        "Group name": "群组名称",
        "relay": "门",
        "motionTime": "移动侦测时间",
        "motionType": "移动侦测类型",
        "postalCode": "邮政编码",
        "floor format": "楼层格式",
        "mobilePhone": "手机号",
        "time format": "时间格式",
        "security relay": "安全继电器",
        "Param": "参数",
        "Offline Code": "离线密码",
        "Add akubela Smart Locks": "添加akubela智能锁",
        "Module Version": "模块版本",
        "Lock Body Version": "锁体版本",
        "Available Version": "可用版本",
        "Please wake up the lock screen and then upgrade.": "请唤醒锁屏，然后升级。",
        "This process will take some time, please be patient.": "这个过程需要一些时间，请耐心等待。",
        "Please confirm that the WiFi network is functioning properly.": "请确认WiFi网络是否正常工作。",
        "Please wake up the lock screen.": "请唤醒锁屏。",
        "This lock has already been added to another apartment.": "这把锁已经被添加到另一个房间",
        "This lock has already been added to the apartment.": "这把锁已经加到房间",
        "Pin Code": "Pin码",
        "Too many failed attempts, please try again in a few minutes.": "失败的尝试太多，请在几分钟后重试",
        "Login Account": "登录账号",
        "Same account cannot login in different ins.": "同一帐户不能登录不同的安装商。",
        "Lock Name": "锁名称",
        "Smart Locks": "智能锁",
        "Add Smart Lock": "添加智能锁",
        "The selected duration cannot be more than one year.": "选的的时长不能超过一年",
        "The end time of the break time cannot be later than the end work time.": "休息时间的结束时间不能晚于结束工作时间。",
        "The start time of the break time cannot be earlier than the start work time.": "休息时间的开始时间不能早于开始工作时间。",
        "The end time of the valid check time cannot be earlier than the end work time.": "有效打卡时间的结束时间不能早于结束工作时间。",
        "The start time of the valid check time cannot be later than the start work time.": "有效打卡时间的开始时间不能晚于开始工作时间。",
        "Deleting failed. The timetable is used by a shift.": "时间表已被使用，删除失败。",
        "Deleting failed. The shift is in use.": "班次已被使用，删除失败。",
        "Deleting failed. The leave type is in use.": "休假类型已被使用，删除失败。",
        "Valid time conflicts with an existing schedule.": "有效时间和已存在的排班冲突。",
        "The timing for multiple schedules must not coincide.": "多个时间表的时间不能重叠。",
        "Attendance Log": "考勤记录",
        "Added Failed!": "添加失败！",
        "Setting WiFi": "设置WiFi",
        "License Plate": "车牌",
        "key": "密码",
        "IQ Offline.": "IQ 离线",
        "{0}Unlock": "{0}解锁",
        "automatically": "自动",
        "manually": "手动",
        "Video Storage": "视频存储",
        "Device(s) for Video Storage": "视频存储设备",
        "The amount of exported data is too large. Please export it in batches.": "导出的数据量过大，请分批导出",
        "Auto-record video when door unlocks": "开门时自动录制视频",
        "Auto-record video during calls": "通话时自动录制视频",
        "Manual video recording in monitoring": "监控中手动录制视频",
        "Saved for 30days/60days/90days": "保存30天/60天/90天",
        "To subscribe, please contact your provider for activation.": "如需订阅，请联系您的服务提供商进行激活。",
        "Saved for {0}days": "保存{0}天",
        "Subscribed Plan": "订阅计划",
        "Supported Devices: {0}": "支持设备：{0}",
        "{0}Lock": "{0}关锁",
        "Video Saving": "视频保存",
        "Download Completed!": "下载完成!",
        "Fail to download.": "下载失败。",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "删除失败！物业管理员已绑定到RentManager账号，您应该首先删除它。",
        "No log to be exported.": "导出记录无数据",
        "capture&Video": "截图&视频",
        "packageDetection": "包裹检测",
        "Time format is invalid.": "时间格式无效。",
        "No permission to export logs of this type.": "导出该类型日志没有权限。",
        "Project type is invalid.": "项目类型无效",
        "Salto Account Blocked.": "Salto账号被锁定",
        "Remote open not in access group.": "不在权限组无法远程开门",
        "SIP Account required.": "SIP账号是必填项",
        "The PIN must be {0} digits.": "PIN必须为{0}位数字。",
        "gatewayConnectionUnavailable": "网关连接不可用。",
        "Invalid Username or Password": "用户名或密码错误。",
        "Account already linked to another user.": "帐户已被其它用户绑定。",
        "The account has been added by another user.": "该帐户已被其他用户添加。",
        "Failed to add. This user already has 5 license plates.": "添加失败，此用户已经有5张车牌",
        "Please at least select a door.": "请至少选择一个门",
        "UHF Card": "UHF卡",
        "personnel": "人员",
        "Parking Lot Name": "停车场名",
        "Controlled Relay": "受控继电器",
        "No Permission": "无权限",
        "Please ensure that all doors in the project are activated at the same time.": "请同时激活项目中的所有门",
        "gatewayBusy": "网关忙",
        "Please set the perimeter door group first.": "请先设置边界门",
        "Please ensure that all doors in the project are renewed at the same time.": "请确保项目中的所有门同时续费",
        "When lockdown is on, the controlled relay cannot be modified.": "锁定状态下，不能修改继电器",
        "DetectionLogs": "检测日志",
        "packageIn": "包裹放入",
        "packageOut": "包裹拿出",
        "View Progress": "查看进度",
        "Check if the WiFi is operating on the 2.4GHz band.": "检查WiFi是否在2.4GHz频段上运行",
        "Verify that the WiFi password is correct.": "验证WiFi密码是否正确。",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "确保在热点配置期间连接到正确的设备热点",
        "Offline Code Unlock": "离线码开门",
        "Salto Token Expired.": "Salto令牌已过期。",
        "Lock Offline": "锁离线",
        "identity information! Please login again": "身份信息！请重新登录",
        "Email is required.": "需要填写电子邮件。",
        "Mobile number is required.": "需要填写手机号码。",
        "You can\'t make payments for offices in different time zones.": "您无法为不同时区的办公项目进行付款",
        "The current scheduling staff exceeds 200 people.": "当前已排班超过200人。",
        "param": "参数",
        "Invalid UserName or Password": "用户名或密码无效",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "您的Salto KS帐户无权限修改锁的名称。",
        "Owner is required.": "需要所属者。",
        "Office is required.": "需要办公室。",
        "PIN or RF Card is required.": "需要PIN或RF卡。",
        "RF card": "门禁卡",
        "Personnel is required.": "需要人员。",
        "email address": "电子邮件地址",
        "mobile number": "手机号码",
        "The length must be less than 32 characters.": "长度必须小于32个字符。",
        "The length must be less than 256 characters.": "长度必须小于256个字符。",
        "Access Group is required.": "需要权限组。",
        "Device is required.": "需要设备。",
        "Admin is required.": "需要管理员。",
        "Mobile number": "手机号码",
        "schedules": "时间表",
        "Timetable name": "时间表名称",
        "Shift name": "班次名称",
        "Leave type": "假别",
        "recheck in time": "重新签到时间",
        "recheck out time": "重新签退时间",
        "The building name": "楼栋名称",
        "Building is required.": "需要楼栋。",
        "selection, The same reader cannot be set for both entry and exit": "选择，入口和出口不能设置相同的读卡器",
        "Door number": "门号",
        "door input cannot be selection duplicated.": "门输入接口不能被重复选择。",
        "Group is required.": "需要群组。",
        "Title can contain up to 32 characters.": "标题最多可包含32个字符。",
        "Content can contain up to 1024 characters.": "内容最多可包含1024个字符。",
        "Content can contain up to 64 characters.": "内容最多可包含64个字符。",
        "Report is required.": "需要报告。",
        "ID is required.": "需要ID。",
        "The office does not exist.": "该办公室不存在。",
        "Office name": "办公室名称",
        "The Temp Key does not exist.": "临时密钥不存在。",
        "autolock time": "自动锁定时间",
        "The User does not exist.": "该用户不存在。",
        "The Installer does not exist.": "该安装商不存在。",
        "The Project does not exist.": "该项目不存在。",
        "The Distributor does not exist.": "该代理商不存在。",
        "The Community Device does not exist.": "社区设备不存在。",
        "The Property Manager does not exist.": "社区管理员不存在。",
        "The Sub Distributor does not exist.": "该子代理商不存在。",
        "The Single Slave does not exist.": "该单住户从账号不存在。",
        "The Property Manager EndUser does not exist.": "该物业管理员终端用户不存在。",
        "The Family Member does not exist.": "该家庭成员不存在。",
        "Set Failed!": "设置失败！",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "您已在30分钟内获取10个离线码，达到上限，请稍后重试。",
        "This Email doesn\'t exist.": "邮箱不存在。",
        "detection type": "检测类型",
        "Device UUID": "设备UUID",
        "smart lock device": "智能锁",
        "You are trying too often, please try again in 5 minutes.": "操作太频繁，请5分钟后重试。",
        "You can only import one file at a time. Please wait for the current import to finish.": "您每次只能导入一个文件，请等待当前文件导入完成。",
        "NVR Name": "NVR名称",
        "NVR Address": "NVR地址",
        "Stay Alarm": "保持报警",
        "Happended On": "发生于",
        "Edit Milesight NVR": "编辑星纵物联NVR",
        "Add Milesight NVR": "添加星纵物联NVR",
        "Auto-record video on motion detection, package detection": "运动检测、包裹检测时自动录制视频",
        "A 7-day free trial is included with your subscription.": "您的订阅包含 7 天免费试用。",
        "For service renewal, please reach out to your provider.": "如需续订服务，请联系您的提供商。",
        "Allow the Property Manager to view recorded videos": "允许物业管理员查看录制的视频",
        "Please ensure the WiFi network is working properly.": "请确保WiFi网络正常工作。",
        "Edit akubela Smart Locks": "编辑akubela智能锁",
        "Upgraded Successfully!": "升级成功！",
        "Upgraded Failed!": "升级失败！",
        "Editing...": "正在编辑...",
        "Edited successfully!": "编辑成功！",
        "Edited Failed!": "编辑失败！",
        "Downloading video...": "正在下载视频...",
        "All Locks": "所有锁",
        "Select Locks": "选择锁",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "akubela智能锁连接到网络后，即可使用{0}位PIN码。请注意，同步后PIN码可能需要一小段时间才能生效。",
        "Please at least select a door or a lock.": "请至少选择一个门或一把锁。",
        "This lock has already been added to your apartment.": "此锁已添加到您的房间。",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "此锁已添加到另一个房间，请联系您的服务提供商寻求帮助。",
        "LockBody Version": "锁体版本",
        "Two-factor Authentication": "双重认证",
        "Monitoring Scope": "监控范围",
        "Stay Duration": "停留时长",
        "Volume Settings": "音量设置",
        "get card list for lock error": "获取锁卡列表错误",
        "get card list parse fail": "获取卡列表解析失败",
        "get pin list for lock error": "获取锁定密钥列表错误",
        "get pin list parse fail": "获取密钥列表解析失败",
        "fingerprint code must be less than 2048 characters or empty.": "指纹代码必须少于2048个字符或为空。",
        "Personnel not in office.": "人员不在办公室。",
        "customize form fail.": "自定义表单失败。",
        "smart lock type error.": "智能锁类型错误。",
        "invalid client id or secret": "无效的客户端ID或密钥",
        "invalid account or password": "无效的帐户或密码",
        "invalid access token": "访问令牌无效",
        "invalid refresh token": "刷新令牌无效",
        "no permission to access this project": "没有访问该项目的权限",
        "Stay Alarm Time": "保持报警时间",
        "This function only support sl20 lock.": "此功能仅支持sl20锁。",
        "Json marshal error.": "Json编组错误。",
        "Json unmarshal error.": "Json解组错误。",
        "Illegal request, not added within valid time.": "非法请求，未在有效时间内添加。",
        "invalid nvr type": "无效的nvr类型",
        "project is empty": "项目为空",
        "project type is invalid": "项目类型无效",
        "owner is invalid": "所属者无效",
        "url is invalid": "url无效",
        "password is invalid": "密码无效",
        "building is invalid": "楼栋无效",
        "fail to get data": "获取数据失败",
        "invalid allow pm view type": "无效的允许pm视图类型",
        "Data not exist.": "数据不存在。",
        "cannot find community PrivateKey.": "找不到社区私钥。",
        "cannot find single PrivateKey.": "找不到单个私钥。",
        "The third party not exist.": "第三方不存在。",
        "{0} and indoor monitors/guard phones": "{0}APP和室内机\/管理机",
        "{0} and indoor monitors/guard phones, with phone as backup": "先呼{0}APP和室内机\/管理机，没人接再呼手机号",
        "Indoor monitors/guard phones with {0} as backup": "先呼室内机\/管理机，没人接再呼{0}App",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "先呼室内机\/管理机，没人接再呼{0}App，最后呼手机号",
        "{0} Intercom Feature": "{0}对讲功能",
        "Capture on {0}": "{0}App上截图",
        "{0} Intercom Feature is not activated or has expired.": "{0}对讲功能未激活或已过期",
        "fingerprint code must be equal 1620 characters or empty.": "指纹代码必须等于1620个字符或为空。",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "为确保升级成功，请确保锁的电池电量高于40%后再继续。",
        "Automatic Locking Time": "自动锁定时间",
        "WiFi Keep-Alive": "WiFi保活",
        "WiFi Setting": "WiFi设置",
        "Connecting the network...": "正在连接网络...",
        "Set successfully!": "设置成功！",
        "The offline code can be used even if the lock is not connected to WiFi.": "即使锁没有连接WiFi，离线码也能使用。",
        "Enabling this feature will increase the lock\'s power consumption.": "开启该功能会增加锁的功耗。",
        "Each offline code can only be used once.": "一个离线码只能使用一次。",
        "Receiver Info": "接收者信息",
        "log id": "登录id",
        "Create HW SN Config Empty SN.": "创建华为SN配置空SN。",
        "The SN": "序列号",
        "SN can contain up to 32 characters.": "SN最多可包含32个字符。",
        "Check HW SN Not Found.": "检查未找到华为SN。",
        "the end user not found": "未找到终端用户",
        "Family Call": "家庭电话",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "升级期间，所有与锁相关的功能将暂时不可用。",
        "8-digit PIN code starting with \"9\" is invalid!": "以“9”开头的 8 位 PIN 码无效！",
        "Lock name length must be between 1 and 50": "锁名称长度必须介于1到50之间",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "使用呼叫手机号服务的人员数量不能超过使用 {0} 对讲服务的人员数量。",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "拥有呼叫手机号服务的管理员数量不能超过拥有 {0} 对讲服务的管理员数量。",
        "charge type": "收费类型",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "使用固定电话服务的人员数量不能超过使用SmartPlus对讲的人员数量。",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "拥有呼叫手机号服务的管理员数量不能超过拥有SmartPlus对讲服务的管理员数量。",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "同一个读卡器不能同时配置为使用 Wiegand 和 RS485。",
        "parameter error": "参数错误",
        "community name already exist": "社区名称已存在",
        "personnel app without intercom feature number": "不带对讲功能号码的人员app",
        "check feature billing charge plan new error": "检查新功能计费方案错误",
        "subscription not found": "未找到订阅",
        "System setting record not found.": "未找到系统设置记录。",
        "Smart home not enabled.": "未启用智能家居。",
        "the apt call type value is invalid.": "apt呼叫方式值无效。",
        "the ip call or sip call value is invalid.": "IP呼叫或SIP呼叫值无效。",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode必须是2-8位数字，但不能是以9开​​头的8位数字或为空。",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard必须是A-F0-9且少于16位或为空。",
        "owner cannot be empty.": "所有者不能为空。",
        "creator cannot be empty.": "创建者不能为空。",
        "the creator type value is invalid": "创建者类型值无效",
        "the IsCreateByPm value is invalid": "IsCreateByPm值无效",
        "the pinCode already exist": "pinCode已存在",
        "the rfCard already exist": "rfCard已经存在",
        "license plate is invalid.": "车牌无效。",
        "owner info is invalid.": "所有者信息无效。",
        "uhf is invalid.": "uhf无效。",
        "time control is invalid.": "时间控制无效。",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "您已达到 5 个车牌的限制，无法添加",
        "the plate already exist": "车牌已经存在",
        "the uhf already exist": "uhf已经存在",
        "empty community": "空的社区",
        "no find license Plate": "找不到车牌",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess 模式必须是0、1或2。",
        "Run field is required when mode is 1 or 2.": "当模式为1或2时，运行字段是必需的。",
        "Serial field is required when mode is 2.": "当模式为2时，序列字段是必需的。",
        "the pin cannot be empty": "pin不能为空",
        "the rfCard cannot be empty": "rfCard不能为空",
        "the IDAccess already exist": "IDAccess已存在",
        "the resident cannot be empty": "住户不能为空",
        "the fingerprint cannot be empty": "指纹不能为空",
        "the face cannot be empty": "人脸不能空",
        "not found pin": "未找到pin",
        "not found rfCard": "未找到rfCard",
        "not found IDAccess": "未找到IDAccess",
        "not found fingerprint": "未找到指纹",
        "not found face": "找不到人脸",
        "face pic is invalid.": "脸部照片无效。",
        "community build and room cannot be empty.": "社区建设和房间不能空。",
        "device info mac cannot be empty.": "设备信息mac不能为空。",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "调度程序类型必须是0、1、2，或者时间格式无效，或者数据标志不在0-127之间。",
        "MAC address cannot be empty.": "MAC地址不能为空。",
        "MAC address 0C1105000000 is not allowed.": "不允许使用MAC地址0C1105000000。",
        "MAC address must be 12 hexadecimal characters.": "MAC地址必须是12个十六进制字符。",
        "Scheduler type value is invalid.": "调度程序类型值无效。",
        "parse is fail": "解析失败",
        "the fingerprint already exist": "指纹已存在",
        "the licensePlate cannot be empty": "车牌不能为空",
        "the licensePlate already exist": "车牌已存在",
        "idaccess run must be 10 digit number or end with -K.": "idaccess运行必须是10位数字或以-K结尾。",
        "idaccess serial must be 9 digit number.": "idaccess序列号必须是9位数字。",
        "relay not in 0-15": "继电器不在0-15",
        "security relay not in 0-3": "安全继电器不在0-3",
        "file name is wrong": "文件名错误",
        "access mode specified": "指定访问模式",
        "create community user accessmode failed.": "创建社区用户访问模式失败。",
        "delete community user accessmode failed.": "删除社区用户访问模式失败。",
        "Cannot delete building because it has associated users.": "无法删除楼栋，因为它有关联用户。",
        "Cannot delete building because it has associated Salto devices.": "无法删除楼栋，因为它关联了Salto设备。",
        "community building not found": "未找到社区楼栋",
        "Invalid Name Display": "无效名称显示",
        "The Community does not exist.": "该社区不存在。",
        "Update CommunityIsInstallerKit Error.": "更新CommunityIsInstallerKit错误。",
        "Dis Not SupportCommunityCalls Error.": "代理商不支持社区呼叫错误。",
        "Community Has Special Device, Not Allowed To Delete.": "社区有特殊设备，不允许删除。",
        "The project smart home switch must be disabled": "项目智能家居开关必须禁用",
        "There are ITec Locks in project": "项目中有ITec锁",
        "There are Salto Locks in project": "项目中有Salto锁",
        "There are Dormakaba Locks in project": "项目中有Dormakaba锁",
        "It is rent manager project": "这是rent manager项目",
        "It is installer account": "这是安装商帐户",
        "contact preference type": "呼叫偏好类型",
        "Floor list is required when not all floors.": "当不是所有楼层时，需要楼层列表。",
        "Building floors list is required when all buildings.": "所有楼栋都需要楼栋楼层清单。",
        "Indoor monitor name is required.": "室内机名称必填。",
        "The primary account is not activated.": "主账户未激活。",
        "You can\'t create more family member accounts.": "您无法创建更多家庭成员帐户。",
        "community user not found": "未找到社区用户",
        "community is empty": "社区为空",
        "the end user not master user": "终端用户不是主账号用户",
        "the end user not member user": "终端用户不是从账号用户",
        "The email already exists and cannot be repeated": "该邮箱已存在，不能重复",
        "The mobile Number already exists": "手机号码已存在",
        "The room number format error.": "房间号格式错误。",
        "community not found": "社区未找到",
        "resident not found": "居民未找到",
        "installer not found": "安装商未找到",
        "Operation Failed!": "操作失败！",
        "You don\'t have operate permission": "您没有操作许可",
        "You cannot select Relay and Door at the same time": "您不能同时选择继电器和门",
        "user don\'t active": "用户未激活",
        "User has expired": "用户已过期",
        "timestamp must be within 3 minutes of current server time": "时间戳必须在当前服务器时间的3分钟内",
        "cannot find single rf Card.": "无法找到单个rf Card。",
        "cannot find community rf Card.": "无法找到社区rf Card。",
        "smartLock model": "智能锁型号",
        "the project does not open smart home": "该项目未打开智能家居",
        "php web server error": "php网络服务器错误",
        "Ins not found.": "未找到Ins。",
        "RentManage Unit Not Set.": "未设置 RentManage单位。",
        "add audit log error": "添加审计日志错误",
        "check building in error": "检查楼栋错误",
        "Special devices cannot be deleted": "特殊设备无法删除",
        "the email is empty": "邮箱是空的",
        "the email format is incorrect": "电子邮件格式不正确",
        "the mobile number is empty": "手机号码为空",
        "the mobile number format is incorrect": "手机号码格式不正确",
        "Site not found": "未找到项目",
        "User not found": "未找到用户",
        "invalid time format": "无效的时间格式",
        "ground floor type": "中间楼层格式",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "开始楼层范围错误，有效值为-10到-1，G0，G1，G2，1到128。",
        "Building ID must be between 1 and 99.": "楼栋ID必须介于1到99之间。",
        "Community building name": "社区楼栋名称",
        "Building ID already exists in this community.": "该社区已存在此建筑物ID。",
        "building ID": "楼栋ID",
        "Community building not found.": "未找到社区楼栋。",
        "Cannot delete building because it has associated devices.": "无法删除楼栋，因为它具有关联设备。",
        "project is not valid": "项目无效",
        "Cannot delete building because it has associated salto devices.": "无法删除楼栋，因为它有关联的salto设备。",
        "Cannot delete building because it has associated iTec devices.": "无法删除楼栋，因为它具有关联的iTec设备。",
        "Cannot delete building because it has associated dormakaba devices.": "无法删除楼栋，因为它具有关联的dormakaba设备。",
        "member limit num": "成员限制数量",
        "Indoor Monitor No Set Error.": "室内机未设置错误。",
        "The room not has indoor": "房间没有室内",
        "check user in building error": "检查用户是否在错误中的楼栋",
        "The name specified is already in use.": "该名称已被使用。",
        "This timeblock overlaps with an existing one. Please adjust it.": "该时间段与已有时间段重叠，请调整。",
        "This door status changed. Please try again.": "该门状态已发生改变。请重试。",
        "the lock can\'t bind this community": "该锁无法绑定此社区",
        "The custom quantity limit has been exceeded!": "已超出自定义数量限制！",
        "This time span overlaps with an existing one. Please adjust it.": "此时间跨度与现有时间跨度重叠。请进行调整。",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "此一次性时间表与现有一次性时间表有效时间重叠。请进行调整。",
        "Operation Failed. Please try again.": "操作失败，请重试。",
        "The image is not a front view.": "该图片不是正面视图。",
        "A mask was detected.": "检测到口罩。",
        "The image resolution is too low.": "图片分辨率太低。",
        "No face was detected.": "未检测到人脸。",
        "The file size is too large.": "文件过大。",
        "The face in the image is too large.": "图片中的脸太大了。",
        "The face in the image is too small.": "图片中的脸太小了。",
        "Multiple faces detected.": "检测到多个人脸",
        "The face is not clear enough.": "面部图像不够清晰。",
        "Face detection failed.": "人脸检测失败。",
        "Please enter a value between 1 and 9999": "请输入1到9999之间的值。",
        "Please select which input your door sensor is connected to.": "请选择您的门磁连接的输入端口。",
        "Add temp key failed, please try it again": "添加临时密钥失败，请重试。",
        "Dis Not Support Dynamic QRCode Error.": "代理商不支持动态二维码错误。",
        "QR code not exist": "二维码不存在",
        "The temp key has expired.": "临时密钥已过期。",
        "The device is not in the office": "该设备不在办公室",
        "The device is already assigned.": "设备已被分配。",
        "The device cannot be assigned to any user.": "该设备不能分配给任何用户。",
        "You cannot select an option with fewer users than the current project members.": "您不能选择用户数量少于当前项目成员数量的选​​项。",
        "File check failed. Please download the latest template and try again.": " 文件检查失败，请下载最新模板并重试。",
        "Dynamic QR Code not active.": "动态二维码未激活。",
        "Dynamic QR Code not enable.": "动态二维码功能未启用。",
        "{0} not found.": "未找到{0}。",
        "Tier charge plan": "阶梯式收费方案",
        "Feature billing charge plan new": "新功能计费方案",
        "Feature billing gradient charge plan": "功能计费梯度收费方案",
        "The exit time cannot be earlier than the entry time.": "离开时间不能早于进入时间。",
        "User Name or Password": "用户名或密码",
        "You can only link up to 5 sites.": "您最多只能关联5个项目。",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "该车牌已注册给一位住户，无法添加到黑名单。",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "该车牌已被列入黑名单，无法注册为车辆。",
        "Elevator not configured in company access floor.": "电梯未在公司通行楼层中配置。",
        "the device is not in the office": "该设备不在办公室",
        "A maximum of 1000 data items can be imported": "最多可以导入1000条数据项",
        "Exit time cannot be later than the current time.": "退出时间不能晚于当前时间。",
        "You can only import a file at a time in the current parking lot.": "在当前停车场，您每次只能导入一个文件。",
        "The license plate is already in the blocklist.": "车牌号已在黑名单中。",
        "Building name too long.": "楼栋名称过长",
        "Unlock failed. Permission denied by user.": "解锁失败。用户拒绝授权。",
        "Please remove the sensor device(s) before disabling this feature.": "请先移除传感器设备，然后再禁用此功能。",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "操作失败！该用户已超过每日15条记录的限制。",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 台公共设备。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 台户内设备。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 栋楼栋。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 个房间。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 位住户。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 位配送人员。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 个门禁权限组。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 个办公组。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 位管理员。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 个公司。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "每个项目最多可添加 {0} 个员工账号。如需添加更多，请联系 Akuvox 技术支持：support{'@'}akuvox.com",
        "cancel": "取消",
        "bluetooth": "蓝牙",
        "Battery Level": "电池电量",


    }
};
